// extracted by mini-css-extract-plugin
export default {"success":"style_success__bd12B","title":"style_title__e29jH","text":"style_text__Mus2U"};